import { Reveal } from "@/components/Reveal";

export default function SectionHeading({ index, eyebrow, title, className = "" }) {
  return (
    <Reveal className={`mb-14 md:mb-20 ${className}`}>
      <div className="flex items-center gap-4 mb-6">
        {index && (
          <span className="font-mono text-xs tracking-[0.2em] text-signal">{index}</span>
        )}
        <span className="h-px w-12 bg-signal/60" aria-hidden="true" />
        <span className="font-mono text-xs tracking-[0.2em] uppercase text-zinc-500">
          {eyebrow}
        </span>
      </div>
      <h2 className="font-display text-4xl sm:text-5xl font-black tracking-tight leading-none max-w-3xl">
        {title}
      </h2>
    </Reveal>
  );
}
